import React from 'react';
import { motion } from 'framer-motion';
import './UpcomingEvents.css';

import postercomp from '../assets/events/poster.jpg';
import python from '../assets/events/python.jpg';
import apptitude from '../assets/events/apptitude.jpg';
import hackathon from '../assets/events/hackathon.jpg';

const eventsData = [
    {
        title: 'Shardeum Mini Hackathon',
        date: 'September 20, 2025',
        time: '09:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        description: 'Join us for an exciting Shardeum Mini Hackathon! Collaborate, innovate, and create amazing projects using the Shardeum blockchain platform. Whether you\'re a beginner or an experienced developer, this event is open to all skill levels. Prizes await the best projects!',
        image: hackathon,
    },
    {
        title: 'Apptitude Test',
        date: 'September 18, 2025',
        time: '12:00 PM',
        venue: 'IT Building, PCE Nagpur',
        description: 'Sharpen your skills with our Apptitude Test! This event is designed to challenge your problem-solving abilities and enhance your logical thinking. It\'s a great opportunity to prepare for technical interviews and improve your aptitude skills. Don\'t miss out on this chance to excel!',
        image: apptitude,
    },
    {
        title: 'Guest Lecture on "Python for Data Science"',
        date: 'September 09, 2025',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        description: 'Join us for an insightful guest lecture on "Python for Data Science". Learn from industry experts about the latest trends and techniques in data science using Python.',
        image: python,
    },
    {
        title: 'Poster Competition',
        date: 'September 03, 2025',
        time: '12:00 PM',
        venue: 'CT DBMS Lab, IT Complex, PCE Nagpur',
        description: 'Unleash your creativity! 🎨 It\'s time to showcase your design skills. Join the "Poster Competition" and present your unique ideas to everyone. Exciting prizes await the winners.',
        image: postercomp,
    }
];

const UpcomingEvents = () => {
    return (
        <section className="upcoming-events-section">
            <h2 className="upcoming-events-title">
                Our This Month <span>Events...</span>
            </h2>
            <div className="events-carousel">
                {eventsData.map((event, index) => (
                    <motion.div 
                        className="upcoming-event-card" 
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        <img src={event.image} alt={event.title} className="upcoming-event-image" />
                        <div className="upcoming-event-details">
                            <h3>{event.title}</h3>
                            <p className="event-info"><strong>Date:</strong> {event.date}</p>
                            <p className="event-info"><strong>Time:</strong> {event.time}</p>
                            <p className="event-info"><strong>Venue:</strong> {event.venue}</p>
                            <p className="event-description-small">{event.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default UpcomingEvents;
